<style src="./ModalList.scss" lang="scss"></style>

<template lang="pug">
  .modal-list
    Modal(
      v-if='isVisible("login") && $accessControl.is(USER_GROUP_GUEST) && !$accessControl.is(USER_GROUP_PERSON)'
      key='login'
      name='login'
    )
      Form.in-modal(type='login')

    Modal(
      v-if='isVisible("register") && $accessControl.is(USER_GROUP_GUEST) && !$accessControl.is(USER_GROUP_PERSON)'
      key='register'
      name='register'
    )
      Form.in-modal(type='register')

    Modal(
      v-if='isVisible("forgotPassword") && $accessControl.is(USER_GROUP_GUEST) && !$accessControl.is(USER_GROUP_PERSON)'
      key='forgotPassword'
      name='forgotPassword'
    )
      Form.in-modal(type='forgotPassword')

    Modal(
      v-if='isVisible("resetPassword") && $accessControl.is(USER_GROUP_GUEST) && !$accessControl.is(USER_GROUP_PERSON)'
      key='resetPassword'
      name='resetPassword'
    )
      Form.in-modal(
        type='resetPassword'
        :data='modalData'
      )

    Modal(
      v-if='isVisible("newplaylist") && $accessControl.is(USER_GROUP_PERSON)'
      key='newplaylist'
      name='newplaylist'
    )
      Form.in-modal(
        type='newplaylist'
        :data='modalData'
      )

    Modal(
      v-if='isVisible("complain") && $accessControl.is(USER_GROUP_PERSON)'
      key='complain'
      name='complain'
    )
      Form.in-modal(
        type='complain'
        :data='modalData'
      )

    Modal(
      v-if='isVisible("confirm")'
      key='confirm'
      name='confirm'
    )
      Confirm(
        :title='modalData.title'
        :caption='modalData.caption'
      )
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    Form: () => import("@/components/Form/Form"),
    Confirm: () => import("@/components/Confirm/Confirm"),
    Modal: () => import("@/components/Modal/Modal")
  },
  computed: {
    ...mapGetters({
      modalName: "modal/name",
      modalData: "modal/data"
    })
  },
  methods: {
    isVisible(name) {
      return this.modalName === name;
    }
  }
};
</script>
